export class UserProperties {
    static getProps() {
        return [
            'name',
            'email',
            'phoneNumber',
            'city',
            'identity',
        ];
    }
    static getPropsWithDocument() {
        return [...this.getProps(), 'taxDocument'];
    }
}
